import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render EE contact us page
 */
const EEContactUsPage = (): React.ReactElement => {
  return (
    <div
      data-testid="ee-contact-us-page-component"
      className="mb-5 font-public-sans"
    >
      <BlockTitle
        text="Contact Us"
        rootClassName="pt-3 mb-5 text-4xl text-xl lg:text-8xl font-medium"
      />

      <p>
        For more information on Emerging Enterprise Award, please email&nbsp;
        <a
          href="mailto:EE2026@rsmsingapore.sg"
          className="font-bold text-blue-175 underline"
        >
          EE2026@rsmsingapore.sg
        </a>
        .
      </p>
    </div>
  );
};

export default EEContactUsPage;
